var map = {
	"./Oval-border.svg": 256,
	"./Oval-filled.svg": 257,
	"./audio.svg": 354,
	"./ear.svg": 355,
	"./finish-exercise.svg": 356,
	"./home.svg": 245,
	"./login.svg": 246,
	"./logo.svg": 357,
	"./spinner.svg": 509,
	"./success-day.svg": 510,
	"./success-training.svg": 511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1825;